import {
  CreatedIcon,
  DeliveredIcon,
  LocationIcon,
  ReceiptIcon,
} from 'static/icons';
import { Text } from 'components';
import { FontSize, ReturnStepsEnum } from 'commons';
import * as S from '../styles';

interface Props {
  currentStep: ReturnStepsEnum;
  isPostOffice: boolean;
}

export function ReturnSteps({ currentStep, isPostOffice }: Props) {
  const { Created, Post, Received, Refund, Cancelled } = ReturnStepsEnum;

  const createdSteps = [Created, Post, Received, Refund, Cancelled];
  const postSteps = [Post, Received, Refund, Cancelled];
  const receivedSteps = [Received, Refund, Cancelled];
  const refundSteps = [Refund, Cancelled];

  return (
    <S.Wrapper $columnsCount={isPostOffice ? 4 : 3}>
      <S.Item $filled={createdSteps.includes(currentStep)}>
        <S.Icon>
          <CreatedIcon />
        </S.Icon>

        <Text size={FontSize.font12}>Solicitação</Text>
      </S.Item>

      {isPostOffice && (
        <>
          <S.Item $filled={postSteps.includes(currentStep)}>
            <S.Icon>
              <LocationIcon />
            </S.Icon>

            <Text size={FontSize.font12}>Postagem</Text>
          </S.Item>
        </>
      )}

      <S.Item $filled={receivedSteps.includes(currentStep)}>
        <S.Icon>
          <DeliveredIcon />
        </S.Icon>

        <Text size={FontSize.font12}>Recebido</Text>
      </S.Item>

      <S.Item $filled={refundSteps.includes(currentStep)}>
        <S.Icon>
          <ReceiptIcon />
        </S.Icon>

        <Text size={FontSize.font12}>
          {currentStep === Cancelled ? 'Cancelado' : 'Estornado'}
        </Text>
      </S.Item>
    </S.Wrapper>
  );
}
